export default "__VITE_ASSET__CRjJROkO__"